"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Links = require("./Links.style");
/* eslint-disable react/jsx-props-no-spreading */


var Link = function Link(_ref) {
  var children = _ref.children,
      color = _ref.color,
      enhanced = _ref.enhanced,
      rest = _objectWithoutProperties(_ref, ["children", "color", "enhanced"]);

  var hover = _react.default.Children.map(children, function () {
    if (_react.default.Children.count(children) === 1 && typeof children === 'string') {
      return true;
    }

    return false;
  })[0];

  return /*#__PURE__*/_react.default.createElement(_Links.StyledLink, Object.assign({
    color: color
  }, rest), /*#__PURE__*/_react.default.createElement(_Links.Wrapper, {
    color: color,
    hover: hover,
    enhanced: enhanced
  }, children));
};

Link.propTypes = {
  enhanced: _propTypes.default.bool,
  color: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired
};
Link.defaultProps = {
  enhanced: false,
  color: '#707070'
};
var _default = Link;
exports.default = _default;